import { LOCAL_STORAGE_PREFIX } from 'config/constants';

export function writeToLocalState(key, state) {
  try {
    localStorage.setItem(
      `${LOCAL_STORAGE_PREFIX}_${key}`,
      JSON.stringify(state),
    );
  } catch (e) {
    throw e;
  }
}

export function getFromLocalState(key) {
  let state = {};
  let item = localStorage.getItem(`${LOCAL_STORAGE_PREFIX}_${key}`);

  if (item === 'undefined') {
    item = '{}';
  }

  try {
    state = JSON.parse(item) || {};
  } catch (e) {
    throw e;
  }

  return state;
}

export function clearLocalState(key) {
  try {
    localStorage.removeItem(`${LOCAL_STORAGE_PREFIX}_${key}`);
  } catch (e) {
    throw e;
  }
}
